// extracted by mini-css-extract-plugin
export default {"tagTitle":"destination-picker_tagTitle__nTutB","icon":"destination-picker_icon__YKY0I","tagList":"destination-picker_tagList__p6cK-","tag":"destination-picker_tag__mZ6A4"};